import BaseApi from './base/BaseApi';

export default class StageApi extends BaseApi {
  static entityName = 'stages';
}
